export { VpPromptAnswer } from './VpPromptAnswer';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPromptAnswer/index.js